//src/styles/custom/box.js

// Fixed box properties and layout utilities
const box = {
  // Icon containers
  icon: {
    sm: {
      width: 36,
      height: 36,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    md: {
      width: 40,
      height: 40,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    lg: {
      width: 48,
      height: 48,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  
  // Padding presets (in theme spacing units)
  padding: {
    card: 2,      // 16px
    section: 3,   // 24px
    item: 1.5,    // 12px
    compact: 1,   // 8px
    loose: 4,     // 32px
  },
  
  // Fixed dimensions
  dimensions: {
    iconBox: 40,
    iconBoxSm: 36,
    iconBoxLg: 48,
    progressHeight: 5,
    chipHeight: 32,
    inputHeight: 40,
    buttonHeight: 44,
  },
  
  // Flex layout utilities
  flex: {
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    between: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    around: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
    evenly: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    start: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    end: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
    },
    columnCenter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    wrap: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
  
  // Grid utilities
  grid: {
    container: {
      display: 'grid',
      gap: 2, // 16px
    },
    twoCol: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 2,
    },
    threeCol: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 2,
    },
  },
  
  // Common component presets
  presets: {
    card: {
      padding: 2,
      borderRadius: 1,
      border: true,
    },
    section: {
      padding: 3,
      marginBottom: 3,
    },
    divider: {
      marginY: 2,
    },
  },
};

export default box;